(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3778],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ CountUp; }
/* harmony export */ });
var __assign=undefined&&undefined.__assign||function(){return(__assign=Object.assign||function(t){for(var i,n=1,a=arguments.length;n<a;n++)for(var s in i=arguments[n])Object.prototype.hasOwnProperty.call(i,s)&&(t[s]=i[s]);return t}).apply(this,arguments)},CountUp=function(){function t(t,i,n){var a=this;this.endVal=i,this.options=n,this.version="2.3.1",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){a.startTime||(a.startTime=t);var i=t-a.startTime;a.remaining=a.duration-i,a.useEasing?a.countDown?a.frameVal=a.startVal-a.easingFn(i,0,a.startVal-a.endVal,a.duration):a.frameVal=a.easingFn(i,a.startVal,a.endVal-a.startVal,a.duration):a.countDown?a.frameVal=a.startVal-(a.startVal-a.endVal)*(i/a.duration):a.frameVal=a.startVal+(a.endVal-a.startVal)*(i/a.duration),a.countDown?a.frameVal=a.frameVal<a.endVal?a.endVal:a.frameVal:a.frameVal=a.frameVal>a.endVal?a.endVal:a.frameVal,a.frameVal=Number(a.frameVal.toFixed(a.options.decimalPlaces)),a.printValue(a.frameVal),i<a.duration?a.rAF=requestAnimationFrame(a.count):null!==a.finalEndVal?a.update(a.finalEndVal):a.callback&&a.callback()},this.formatNumber=function(t){var i,n,s,e,r=t<0?"-":"";i=Math.abs(t).toFixed(a.options.decimalPlaces);var o=(i+="").split(".");if(n=o[0],s=o.length>1?a.options.decimal+o[1]:"",a.options.useGrouping){e="";for(var l=0,h=n.length;l<h;++l)0!==l&&l%3==0&&(e=a.options.separator+e),e=n[h-l-1]+e;n=e}return a.options.numerals&&a.options.numerals.length&&(n=n.replace(/[0-9]/g,function(t){return a.options.numerals[+t]}),s=s.replace(/[0-9]/g,function(t){return a.options.numerals[+t]})),r+a.options.prefix+n+s+a.options.suffix},this.easeOutExpo=function(t,i,n,a){return n*(1-Math.pow(2,-10*t/a))*1024/1023+i},this.options=__assign(__assign({},this.defaults),n),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(i),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof t?document.getElementById(t):t,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined","undefined"!=typeof window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,t):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push(function(){return a.handleScroll(a)}),window.onscroll=function(){window.onScrollFns.forEach(function(t){return t()})},this.handleScroll(this)))}return t.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.getBoundingClientRect(),a=n.top+n.height+window.pageYOffset;a<i&&a>window.scrollY&&t.paused?(t.paused=!1,setTimeout(function(){return t.start()},t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):window.scrollY>a&&!t.paused&&t.reset()}},t.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},t.prototype.start=function(t){this.error||(this.callback=t,this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},t.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},t.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},t.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,this.finalEndVal||this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},t.prototype.printValue=function(t){var i=this.formattingFn(t);"INPUT"===this.el.tagName?this.el.value=i:"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=i:this.el.innerHTML=i},t.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},t.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},t.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},t}();

/***/ }),

/***/ 7654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(81763);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 81763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ Modal_ModalActions; },
  "S": function() { return /* reexport */ Modal_ModalInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/Modal/Spacer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n  width: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Spacer = function(param) {
    var _size = param.size, size = _size === void 0 ? "md" : _size;
    var spacing = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni).spacing;
    var s;
    switch(size){
        case "lg":
            s = spacing[6];
            break;
        case "sm":
            s = spacing[2];
            break;
        case "md":
        default:
            s = spacing[4];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpacer, {
        size: s
    });
};
var StyledSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f12c58f-0"
})(_templateObject(), function(props) {
    return props.size;
}, function(props) {
    return props.size;
});
/* harmony default export */ var Modal_Spacer = (Spacer);

;// CONCATENATED MODULE: ./src/components/Modal/ModalActions.tsx

function ModalActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        "00;\n  display: flex;\n  margin: 0;\n  padding: ",
        "px 0;\n"
    ]);
    ModalActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ModalActions = function(param) {
    var children = param.children;
    var l = react.Children.toArray(children).length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalActions, {
        children: react.Children.map(children, function(child, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalAction, {
                        children: child
                    }),
                    i < l - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Spacer, {})
                ]
            });
        })
    });
};
var StyledModalActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65c48b8e-0"
})(ModalActions_templateObject(), function(props) {
    return props.theme.colors.primaryDark;
}, function(props) {
    return props.theme.spacing[4];
});
var StyledModalAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-65c48b8e-1"
})(_templateObject1());
/* harmony default export */ var Modal_ModalActions = (ModalActions);

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/components/Modal/ModalInput.tsx

function ModalInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  padding: 8px 16px 8px 0;\n  width: 100%;\n"
    ]);
    ModalInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  width: 60px;\n  margin: 0 8px;\n  padding: 0 8px;\n  border: none;\n\n  ",
        " {\n    width: 80px;\n  }\n\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    ModalInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -22px;\n  a {\n    display: inline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var StyledTokenInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a147be18-0"
})(ModalInput_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning;
    return isWarning ? theme.colors.warning : theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-a147be18-1"
})(ModalInput_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a147be18-2"
})(_templateObject2());
var ModalInput = function(param) {
    var max = param.max, symbol = param.symbol, onChange = param.onChange, onSelectMax = param.onSelectMax, value = param.value, addLiquidityUrl = param.addLiquidityUrl, inputTitle = param.inputTitle, _decimals = param.decimals, decimals = _decimals === void 0 ? 18 : _decimals;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var isBalanceZero = max === "0" || !max;
    var displayBalance = function(balance) {
        if (isBalanceZero) {
            return "0";
        }
        var balanceUnits = (0,lib_esm/* parseUnits */.vz)(balance, decimals);
        return (0,formatBalance/* formatBigNumber */.dp)(balanceUnits, decimals, decimals);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTokenInput, {
                isWarning: isBalanceZero,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        pl: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: inputTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Balance: %balance%", {
                                    balance: displayBalance(max)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "flex-end",
                        justifyContent: "space-around",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                                pattern: "^[0-9]*[.,]?[0-9]{0,".concat(decimals, "}$"),
                                inputMode: "decimal",
                                step: "any",
                                min: "0",
                                onChange: onChange,
                                placeholder: "0",
                                value: value
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                scale: "sm",
                                onClick: onSelectMax,
                                mr: "8px",
                                children: t("Max")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "16px",
                                children: symbol
                            })
                        ]
                    })
                ]
            }),
            isBalanceZero && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledErrorMessage, {
                fontSize: "14px",
                color: "failure",
                children: [
                    t("No tokens to stake"),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        fontSize: "14px",
                        bold: false,
                        href: addLiquidityUrl,
                        external: true,
                        color: "failure",
                        children: t("Get %symbol%", {
                            symbol: symbol
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Modal_ModalInput = (ModalInput);

;// CONCATENATED MODULE: ./src/components/Modal/index.ts




/***/ }),

/***/ 16519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "sA": function() { return /* reexport */ harvestFarm; },
  "AQ": function() { return /* reexport */ stakeFarm; },
  "dU": function() { return /* reexport */ unstakeFarm; }
});

// UNUSED EXPORTS: estimateGas, getActivePools

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 ? _args[4] : void 0;
                    ;
                    if (contract[methodName]) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                case 4:
                    _ctx.next = 6;
                    return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        overrides
                    ]));
                case 6:
                    rawGasEstimation = _ctx.sent;
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return _ctx.abrupt("return", gasEstimation);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, gasMarginPer10000 = _args.length > 4 && _args[4] !== void 0 ? _args[4] : 1000;
                    ;
                    _ctx.next = 4;
                    return estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000);
                case 4:
                    gasEstimation = _ctx.sent;
                    _ctx.next = 7;
                    return (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                        (0,_object_spread/* default */.Z)({
                            gasLimit: gasEstimation
                        }, overrides)
                    ]));
                case 7:
                    tx = _ctx.sent;
                    return _ctx.abrupt("return", tx);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(37519);
// EXTERNAL MODULE: ./src/utils/getGasPrice.ts
var getGasPrice = __webpack_require__(76582);
;// CONCATENATED MODULE: ./src/utils/calls/farms.ts







var options = {
    gasLimit: config/* DEFAULT_GAS_LIMIT */.QL
};
var stakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(masterChefContract, pid, amount) {
        var gasPrice, value;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, value, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function stakeFarm(masterChefContract, pid, amount) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(masterChefContract, pid, amount) {
        var gasPrice, value;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return _ctx.abrupt("return", masterChefContract.withdraw(pid, value, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function unstakeFarm(masterChefContract, pid, amount) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(masterChefContract, pid) {
        var gasPrice;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gasPrice = (0,getGasPrice/* default */.Z)();
                    return _ctx.abrupt("return", masterChefContract.deposit(pid, "0", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                        gasPrice: gasPrice
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function harvestFarm(masterChefContract, pid) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./src/utils/providers.ts + 1 modules
var providers = __webpack_require__(65684);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts




/* eslint-disable import/prefer-default-export */ 





/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(block) {
        var eligiblePools, blockNumber, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _ctx.t0 = block;
                    if (_ctx.t0) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 5;
                    return providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber();
                case 5:
                    _ctx.t0 = _ctx.sent;
                case 6:
                    blockNumber = _ctx.t0;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    _ctx.t1 = _sliced_to_array/* default */.Z;
                    _ctx.next = 12;
                    return Promise.all([
                        (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                        (0,multicall/* default */.Z)(sousChefV2, endBlockCalls), 
                    ]);
                case 12:
                    _ctx.t2 = _ctx.sent;
                    ref = (0, _ctx.t1)(_ctx.t2, 2);
                    startBlocks = ref[0];
                    endBlocks = ref[1];
                    return _ctx.abrupt("return", eligiblePools.reduce(function(accum, poolCheck, index) {
                        var startBlock = startBlocks[index] ? new (bignumber_default())(startBlocks[index]) : null;
                        var endBlock = endBlocks[index] ? new (bignumber_default())(endBlocks[index]) : null;
                        if (!startBlock || !endBlock) {
                            return accum;
                        }
                        if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                            return accum;
                        }
                        return (0,_to_consumable_array/* default */.Z)(accum).concat([
                            poolCheck
                        ]);
                    }, []));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_constants_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29748);
// Constructing the two forward-slash-separated parts of the 'Add Liquidity' URL
// Each part of the url represents a different side of the LP pair.

var getLiquidityUrlPathParts = function(param) {
    var quoteTokenAddress = param.quoteTokenAddress, tokenAddress = param.tokenAddress;
    var wBnbAddress = config_constants_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.wbnb.address */ .ds.wbnb.address;
    var firstPart = !quoteTokenAddress || quoteTokenAddress === wBnbAddress ? "BNB" : quoteTokenAddress;
    var secondPart = !tokenAddress || tokenAddress === wBnbAddress ? "BNB" : tokenAddress;
    return "".concat(firstPart, "/").concat(secondPart);
};
/* harmony default export */ __webpack_exports__["Z"] = (getLiquidityUrlPathParts);


/***/ }),

/***/ 37031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ FarmsContext; },
  "Z": function() { return /* binding */ Farms_Farms; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(91186);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(20508);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(40508);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(17166);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.ts
var useIntersectionObserver = __webpack_require__(76538);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/utils/apr.ts + 1 modules
var apr = __webpack_require__(26672);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/utils/latinise.ts
var latinise = __webpack_require__(11438);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/state/user/actions.ts
var actions = __webpack_require__(46245);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/PageHeader/index.ts + 1 modules
var PageHeader = __webpack_require__(44482);
// EXTERNAL MODULE: ./src/components/SearchInput/index.ts + 1 modules
var SearchInput = __webpack_require__(14450);
// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(37370);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
// EXTERNAL MODULE: ./src/components/ToggleView/ToggleView.tsx
var ToggleView = __webpack_require__(31455);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(40447);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/views/Farms/components/getDisplayApr.ts
var getDisplayApr = __webpack_require__(64853);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpointsContext.ts
var useMatchBreakpointsContext = __webpack_require__(98946);
// EXTERNAL MODULE: ./src/hooks/useDelayedUnmount.ts
var useDelayedUnmount = __webpack_require__(30798);
// EXTERNAL MODULE: ./src/components/Tags.tsx
var Tags = __webpack_require__(69160);
// EXTERNAL MODULE: ./src/views/Farms/components/FarmCard/ApyButton.tsx
var ApyButton = __webpack_require__(75313);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(37519);
// EXTERNAL MODULE: ./src/utils/getLiquidityUrlPathParts.ts
var getLiquidityUrlPathParts = __webpack_require__(51912);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Apr.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n\n  button {\n    width: 20px;\n    height: 20px;\n\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 60px;\n  text-align: left;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172ef27-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var AprWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a172ef27-1"
})(_templateObject1());
var Apr = function(param) {
    var value = param.value, pid = param.pid, lpLabel = param.lpLabel, lpSymbol = param.lpSymbol, multiplier = param.multiplier, tokenAddress = param.tokenAddress, quoteTokenAddress = param.quoteTokenAddress, wkdPrice = param.wkdPrice, originalValue = param.originalValue, _hideButton = param.hideButton, hideButton = _hideButton === void 0 ? false : _hideButton;
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: quoteTokenAddress,
        tokenAddress: tokenAddress
    });
    var addLiquidityUrl = "".concat(config/* BASE_ADD_LIQUIDITY_URL */.wI, "/").concat(liquidityUrlPathParts);
    console.log("originalValue: ", originalValue);
    return originalValue !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: originalValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApyButton/* default */.Z, {
            variant: hideButton ? "text" : "text-and-button",
            pid: pid,
            lpSymbol: lpSymbol,
            lpLabel: lpLabel,
            multiplier: multiplier,
            wkdPrice: wkdPrice,
            apr: originalValue,
            displayApr: value,
            addLiquidityUrl: addLiquidityUrl
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AprWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: 60
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AprWrapper, {
            children: [
                originalValue,
                "%"
            ]
        })
    });
};
/* harmony default export */ var FarmTable_Apr = (Apr);

// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(95239);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Farm.tsx

function Farm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 16px;\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    padding-left: 32px;\n  }\n"
    ]);
    Farm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Farm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 8px;\n  width: 32px;\n\n  ",
        " {\n    width: 40px;\n  }\n"
    ]);
    Farm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Farm_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-774c2926-0"
})(Farm_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TokenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-774c2926-1"
})(Farm_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Farm = function(param) {
    var token = param.token, quoteToken = param.quoteToken, label = param.label, pid = param.pid;
    var stakedBalance = (0,hooks/* useFarmUser */.Dx)(pid).stakedBalance;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var rawStakedBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance);
    var handleRenderFarming = function() {
        if (rawStakedBalance) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "secondary",
                fontSize: "12px",
                bold: true,
                textTransform: "uppercase",
                children: t("Farming")
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Farm_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                    variant: "inverted",
                    primaryToken: token,
                    secondaryToken: quoteToken,
                    width: 40,
                    height: 40
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    handleRenderFarming(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        children: label
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmTable_Farm = (Farm);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Earned.tsx

function Earned_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    Earned_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Amount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-937c6ce1-0"
})(Earned_templateObject(), function(param) {
    var earned = param.earned, theme = param.theme;
    return earned ? theme.colors.text : theme.colors.textDisabled;
});
var Earned = function(param) {
    var earnings = param.earnings, userDataReady = param.userDataReady;
    if (userDataReady) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount, {
            earned: earnings,
            children: earnings.toLocaleString()
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount, {
        earned: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: 60
        })
    });
};
/* harmony default export */ var FarmTable_Earned = (Earned);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Details.tsx

function Details_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  padding-right: 8px;\n  color: ",
        ";\n\n  ",
        " {\n    padding-right: 0px;\n  }\n"
    ]);
    Details_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Details_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  height: 20px;\n"
    ]);
    Details_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Details_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67c07f9c-0"
})(Details_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronDown/* default */.Z).withConfig({
    componentId: "sc-67c07f9c-1"
})(Details_templateObject1(), function(param) {
    var toggled = param.toggled;
    return toggled ? "rotate(180deg)" : "rotate(0)";
});
var Details = function(param) {
    var actionPanelToggled = param.actionPanelToggled;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpointsContext/* default */.Z)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Details_Container, {
        children: [
            !isDesktop && t("Details"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                color: "primary",
                toggled: actionPanelToggled
            })
        ]
    });
};
/* harmony default export */ var FarmTable_Details = (Details);

// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(62276);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Multiplier.tsx

function Multiplier_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    Multiplier_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Multiplier_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 36px;\n  text-align: right;\n  margin-right: 14px;\n\n  ",
        " {\n    text-align: left;\n    margin-right: 0;\n  }\n"
    ]);
    Multiplier_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ReferenceElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7ab0ff2-0"
})(Multiplier_templateObject());
var MultiplierWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7ab0ff2-1"
})(Multiplier_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Multiplier_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7ab0ff2-2"
})(_templateObject2());
var Multiplier = function(param) {
    var multiplier = param.multiplier;
    var displayMultiplier = multiplier ? multiplier.toLowerCase() : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 30
    });
    var t = (0,Localization/* useTranslation */.$G)().t;
    var tooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("The Multiplier represents the proportion of WKD rewards each farm receives, as a proportion of the WKD produced each block.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                my: "24px",
                children: t("For example, if a 1x farm received 1 WKD per block, a 40x farm would receive 40 WKD per block.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("This amount is already included in all APR calculations for the farm.")
            })
        ]
    });
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Multiplier_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiplierWrapper, {
                children: displayMultiplier
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferenceElement, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                    color: "textSubtle"
                })
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var FarmTable_Multiplier = (Multiplier);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Liquidity.tsx

function Liquidity_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    Liquidity_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Liquidity_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 110px;\n  font-weight: 600;\n  text-align: right;\n  margin-right: 14px;\n\n  ",
        " {\n    text-align: left;\n    margin-right: 0;\n  }\n"
    ]);
    Liquidity_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Liquidity_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    Liquidity_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Liquidity_ReferenceElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-953e5ae9-0"
})(Liquidity_templateObject());
var LiquidityWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-953e5ae9-1"
})(Liquidity_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Liquidity_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-953e5ae9-2"
})(Liquidity_templateObject2());
var Liquidity = function(param) {
    var liquidity = param.liquidity;
    var displayLiquidity = liquidity && liquidity.gt(0) ? "$".concat(Number(liquidity).toLocaleString(undefined, {
        maximumFractionDigits: 0
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 60
    });
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,useTooltip/* default */.Z)(t("Total value of the funds in this farm\u2019s liquidity pool"), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Liquidity_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LiquidityWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: displayLiquidity
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Liquidity_ReferenceElement, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                    color: "textSubtle"
                })
            }),
            tooltipVisible && tooltip
        ]
    });
};
/* harmony default export */ var FarmTable_Liquidity = (Liquidity);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/state/index.ts + 36 modules
var state = __webpack_require__(84143);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 1 modules
var farms = __webpack_require__(36393);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useHarvestFarm.ts
var useHarvestFarm = __webpack_require__(86507);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  border: 2px solid ",
        ";\n  border-radius: 16px;\n  flex-grow: 1;\n  flex-basis: 0;\n  margin-bottom: 16px;\n\n  ",
        " {\n    margin-left: 12px;\n    margin-right: 12px;\n    margin-bottom: 0;\n    max-height: 100px;\n  }\n\n  ",
        " {\n    margin-left: 48px;\n    margin-right: 0;\n    margin-bottom: 0;\n    max-height: 100px;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ef751c-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var ActionTitles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ef751c-1"
})(styles_templateObject1());
var ActionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ef751c-2"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/HarvestAction.tsx


















var HarvestAction = function(param) {
    var pid = param.pid, userData = param.userData, userDataReady = param.userDataReady;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var earningsBigNumber = new (bignumber_default())(userData.earnings);
    var wkdPrice = (0,hooks/* usePriceWkdBusd */.ek)();
    var earnings = bigNumber/* BIG_ZERO */.HW;
    var earningsBusd = 0;
    var displayBalance = userDataReady ? earnings.toLocaleString() : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        width: 60
    });
    // If user didn't connect wallet default balance will be 0
    if (!earningsBigNumber.isZero()) {
        earnings = (0,formatBalance/* getBalanceAmount */.U4)(earningsBigNumber, 9);
        earningsBusd = earnings.multipliedBy(wkdPrice).toNumber();
        displayBalance = earnings.toFixed(3, (bignumber_default()).ROUND_DOWN);
    }
    var onReward = (0,useHarvestFarm/* default */.Z)(pid).onReward;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionTitles, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "secondary",
                        fontSize: "12px",
                        pr: "4px",
                        children: "WKD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Earned")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                children: displayBalance
                            }),
                            earningsBusd > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: earningsBusd,
                                unit: " USD",
                                prefix: "~"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: earnings.eq(0) || pendingTx || !userDataReady,
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var receipt;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetchWithCatchTxError(function() {
                                            return onReward();
                                        });
                                    case 2:
                                        receipt = _ctx.sent;
                                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                            toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                                txHash: receipt.transactionHash,
                                                children: t("Your %symbol% earnings have been sent to your wallet!", {
                                                    symbol: "CAKE"
                                                })
                                            }));
                                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                                account: account,
                                                pids: [
                                                    pid
                                                ]
                                            }));
                                        }
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        ml: "4px",
                        children: pendingTx ? t("Harvesting") : t("Harvest")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Actions_HarvestAction = (HarvestAction);

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(72943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useApproveFarm.ts
var useApproveFarm = __webpack_require__(76807);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useStakeFarms.ts
var useStakeFarms = __webpack_require__(60508);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useUnstakeFarms.ts
var useUnstakeFarms = __webpack_require__(97321);
// EXTERNAL MODULE: ./src/views/Farms/components/DepositModal.tsx
var DepositModal = __webpack_require__(37272);
// EXTERNAL MODULE: ./src/views/Farms/components/WithdrawModal.tsx
var WithdrawModal = __webpack_require__(71154);
// EXTERNAL MODULE: ./src/views/Farms/components/StakedLP.tsx
var StakedLP = __webpack_require__(58660);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/StakedAction.tsx




function StakedAction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    StakedAction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

























var IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7bf883db-0"
})(StakedAction_templateObject());
var Staked = function(param) {
    var pid = param.pid, apr = param.apr, multiplier = param.multiplier, lpSymbol = param.lpSymbol, lpLabel = param.lpLabel, lpAddresses = param.lpAddresses, quoteToken = param.quoteToken, token = param.token, userDataReady = param.userDataReady, displayApr = param.displayApr, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref1 = (0,hooks/* useFarmUser */.Dx)(pid), allowance = ref1.allowance, tokenBalance = ref1.tokenBalance, stakedBalance = ref1.stakedBalance;
    var onStake = (0,useStakeFarms/* default */.Z)(pid).onStake;
    var onUnstake = (0,useUnstakeFarms/* default */.Z)(pid).onUnstake;
    var router = (0,next_router.useRouter)();
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var wkdPrice = (0,hooks/* usePriceWkdBusd */.ek)();
    var isApproved = account && allowance && allowance.isGreaterThan(0);
    var lpAddress = (0,addressHelpers/* getAddress */.Kn)(lpAddresses);
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: quoteToken.address,
        tokenAddress: token.address
    });
    var addLiquidityUrl = "".concat(config/* BASE_ADD_LIQUIDITY_URL */.wI, "/").concat(liquidityUrlPathParts);
    var handleStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onStake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                account: account,
                                pids: [
                                    pid
                                ]
                            }));
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleStake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnstake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onUnstake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                account: account,
                                pids: [
                                    pid
                                ]
                            }));
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnstake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DepositModal/* default */.Z, {
        max: tokenBalance,
        lpPrice: lpPrice,
        lpLabel: lpLabel,
        apr: apr,
        displayApr: displayApr,
        stakedBalance: stakedBalance,
        onConfirm: handleStake,
        tokenName: lpSymbol,
        multiplier: multiplier,
        addLiquidityUrl: addLiquidityUrl,
        wkdPrice: wkdPrice
    })), 1), onPresentDeposit = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawModal/* default */.Z, {
        max: stakedBalance,
        onConfirm: handleUnstake,
        tokenName: lpSymbol
    })), 1), onPresentWithdraw = ref3[0];
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onApprove = (0,useApproveFarm/* default */.Z)(lpContract).onApprove;
    var handleApprove = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return onApprove();
                    });
                case 2:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: receipt.transactionHash
                        }));
                        dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                            account: account,
                            pids: [
                                pid
                            ]
                        }));
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onApprove,
        dispatch,
        account,
        pid,
        t,
        toastSuccess,
        fetchWithCatchTxError
    ]);
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Start Farming")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                        width: "100%"
                    })
                })
            ]
        });
    }
    if (isApproved) {
        if (stakedBalance.gt(0)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionTitles, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "secondary",
                                fontSize: "12px",
                                pr: "4px",
                                children: lpSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                textTransform: "uppercase",
                                color: "textSubtle",
                                fontSize: "12px",
                                children: t("Staked")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedLP/* default */.Z, {
                                stakedBalance: stakedBalance,
                                lpSymbol: lpSymbol,
                                quoteTokenSymbol: quoteToken.symbol,
                                tokenSymbol: token.symbol,
                                lpTotalSupply: lpTotalSupply,
                                tokenAmountTotal: tokenAmountTotal,
                                quoteTokenAmountTotal: quoteTokenAmountTotal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButtonWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        variant: "secondary",
                                        onClick: onPresentWithdraw,
                                        mr: "6px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                            color: "primary",
                                            width: "14px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        variant: "secondary",
                                        onClick: onPresentDeposit,
                                        disabled: [
                                            "history",
                                            "archived"
                                        ].some(function(item) {
                                            return router.pathname.includes(item);
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                            color: "primary",
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionTitles, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            textTransform: "uppercase",
                            color: "textSubtle",
                            fontSize: "12px",
                            pr: "4px",
                            children: t("Stake")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            textTransform: "uppercase",
                            color: "secondary",
                            fontSize: "12px",
                            children: lpSymbol
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        onClick: onPresentDeposit,
                        variant: "secondary",
                        disabled: [
                            "history",
                            "archived"
                        ].some(function(item) {
                            return router.pathname.includes(item);
                        }),
                        children: t("Stake LP")
                    })
                })
            ]
        });
    }
    if (!userDataReady) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Start Farming")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 180,
                        marginBottom: 28,
                        marginTop: 14
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTitles, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    bold: true,
                    textTransform: "uppercase",
                    color: "textSubtle",
                    fontSize: "12px",
                    children: t("Enable Farm")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    width: "100%",
                    disabled: pendingTx,
                    onClick: handleApprove,
                    variant: "secondary",
                    children: t("Enable")
                })
            })
        ]
    });
};
/* harmony default export */ var StakedAction = (Staked);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Actions/ActionPanel.tsx



function ActionPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    max-height: 0px;\n  }\n  to {\n    max-height: 500px;\n  }\n"
    ]);
    ActionPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    max-height: 500px;\n  }\n  to {\n    max-height: 0px;\n  }\n"
    ]);
    ActionPanel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ActionPanel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    ActionPanel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        " 300ms linear forwards\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n  display: flex;\n  width: 100%;\n  flex-direction: column-reverse;\n  padding: 24px;\n\n  ",
        " {\n    flex-direction: row;\n    padding: 16px 32px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n\n  ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 200px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 4px 0px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}












var expandAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ActionPanel_templateObject());
var collapseAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(ActionPanel_templateObject1());
var ActionPanel_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea28eb8-0"
})(_templateObject4(), function(param) {
    var expanded = param.expanded;
    return expanded ? (0,styled_components_browser_esm/* css */.iv)(ActionPanel_templateObject2(), expandAnimation) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), collapseAnimation);
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-1ea28eb8-1"
})(_templateObject5());
var StakeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea28eb8-2"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ActionPanel_ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea28eb8-3"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea28eb8-4"
})(_templateObject8());
var ValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea28eb8-5"
})(_templateObject9());
var ValueWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1ea28eb8-6"
})(_templateObject10());
var ActionPanel = function(param) {
    var details = param.details, apr = param.apr, multiplier = param.multiplier, liquidity = param.liquidity, userDataReady = param.userDataReady, expanded = param.expanded;
    var farm = details;
    var isDesktop = (0,useMatchBreakpointsContext/* default */.Z)().isDesktop;
    var ref = (0,Localization/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var isActive = farm.multiplier !== "0X";
    var quoteToken = farm.quoteToken, token = farm.token;
    var lpLabel = farm.lpSymbol && farm.lpSymbol.toUpperCase().replace("PANCAKE", "");
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: quoteToken.address,
        tokenAddress: token.address
    });
    var lpAddress = (0,addressHelpers/* getAddress */.Kn)(farm.lpAddresses);
    var bsc = (0,utils/* getBscScanLink */.s6)(lpAddress, "address");
    var info = "/info/pool/".concat(lpAddress);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionPanel_Container, {
        expanded: expanded,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueContainer, {
                        children: [
                            farm.isCommunity && farm.auctionHostingEndDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: t("Auction Hosting Ends")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        paddingLeft: "4px",
                                        children: new Date(farm.auctionHostingEndDate).toLocaleString(locale, {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric"
                                        })
                                    })
                                ]
                            }),
                            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: t("APR")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Apr, (0,_object_spread/* default */.Z)({}, apr))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: t("Multiplier")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Multiplier, (0,_object_spread/* default */.Z)({}, multiplier))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: t("Liquidity")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Liquidity, (0,_object_spread/* default */.Z)({}, liquidity))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                            href: "/add/".concat(liquidityUrlPathParts),
                            children: t("Get %symbol%", {
                                symbol: lpLabel
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                        href: bsc,
                        children: t("View Contract")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionPanel_ActionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions_HarvestAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                        userDataReady: userDataReady
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                        userDataReady: userDataReady,
                        lpLabel: lpLabel,
                        displayApr: apr.value
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var Actions_ActionPanel = (ActionPanel);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/CellLayout.tsx

function CellLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: left;\n"
    ]);
    CellLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CellLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 24px;\n  display: flex;\n  align-items: center;\n"
    ]);
    CellLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dba8a3c4-0"
})(CellLayout_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dba8a3c4-1"
})(CellLayout_templateObject1());
var CellLayout = function(param) {
    var _label = param.label, label = _label === void 0 ? "" : _label, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                children: children
            })
        ]
    });
};
/* harmony default export */ var FarmTable_CellLayout = (CellLayout);

;// CONCATENATED MODULE: ./src/views/Farms/components/types.ts
var MobileColumnSchema = [
    {
        id: 1,
        name: "farm",
        sortable: true,
        label: ""
    },
    {
        id: 2,
        name: "earned",
        sortable: true,
        label: "Earned"
    },
    {
        id: 3,
        name: "apr",
        sortable: true,
        label: "APR"
    },
    {
        id: 6,
        name: "details",
        sortable: true,
        label: ""
    }, 
];
var DesktopColumnSchema = [
    {
        id: 1,
        name: "farm",
        sortable: true,
        label: ""
    },
    {
        id: 2,
        name: "type",
        sortable: false,
        label: ""
    },
    {
        id: 3,
        name: "earned",
        sortable: true,
        label: "Earned"
    },
    {
        id: 4,
        name: "apr",
        sortable: true,
        label: "APR"
    },
    {
        id: 5,
        name: "liquidity",
        sortable: true,
        label: "Liquidity"
    },
    {
        id: 6,
        name: "multiplier",
        sortable: true,
        label: "Multiplier"
    },
    {
        id: 7,
        name: "details",
        sortable: true,
        label: ""
    }, 
];

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/Row.tsx



function Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding-right: 8px;\n\n  ",
        " {\n    padding-right: 32px;\n  }\n"
    ]);
    Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Row_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  border-bottom: 2px solid ",
        ";\n"
    ]);
    Row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Row_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0 24px 16px;\n"
    ]);
    Row_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Row_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n  padding-bottom: 24px;\n"
    ]);
    Row_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Row_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 24px;\n"
    ]);
    Row_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

















var cells = {
    apr: FarmTable_Apr,
    farm: FarmTable_Farm,
    earned: FarmTable_Earned,
    details: FarmTable_Details,
    multiplier: FarmTable_Multiplier,
    liquidity: FarmTable_Liquidity
};
var CellInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9191884b-0"
})(Row_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var StyledTr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-9191884b-1"
})(Row_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});
var EarnedMobileCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-9191884b-2"
})(Row_templateObject2());
var AprMobileCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-9191884b-3"
})(Row_templateObject3());
var FarmMobileCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-9191884b-4"
})(Row_templateObject4());
var Row = function(props) {
    var details = props.details, userDataReady = props.userDataReady, initialActivity = props.initialActivity;
    var hasSetInitialValue = (0,react.useRef)(false);
    var hasStakedAmount = !!(0,hooks/* useFarmUser */.Dx)(details.pid).stakedBalance.toNumber();
    var ref = (0,react.useState)(hasStakedAmount), actionPanelExpanded = ref[0], setActionPanelExpanded = ref[1];
    var shouldRenderChild = (0,useDelayedUnmount/* default */.Z)(actionPanelExpanded, 300);
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toggleActionPanel = function() {
        setActionPanelExpanded(!actionPanelExpanded);
    };
    (0,react.useEffect)(function() {
        setActionPanelExpanded(hasStakedAmount);
    }, [
        hasStakedAmount
    ]);
    (0,react.useEffect)(function() {
        if (initialActivity && hasSetInitialValue.current === false) {
            setActionPanelExpanded(initialActivity);
            hasSetInitialValue.current = true;
        }
    }, [
        initialActivity
    ]);
    var ref1 = (0,useMatchBreakpointsContext/* default */.Z)(), isDesktop = ref1.isDesktop, isMobile = ref1.isMobile;
    var isSmallerScreen = !isDesktop;
    var tableSchema = isSmallerScreen ? MobileColumnSchema : DesktopColumnSchema;
    var columnNames = tableSchema.map(function(column) {
        return column.name;
    });
    var handleRenderRow = function() {
        if (!isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTr, {
                onClick: toggleActionPanel,
                children: Object.keys(props).map(function(key) {
                    var columnIndex = columnNames.indexOf(key);
                    if (columnIndex === -1) {
                        return null;
                    }
                    switch(key){
                        case "type":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    style: {
                                        width: "100px"
                                    },
                                    children: props[key] === "community" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* FarmAuctionTag */.Vi, {
                                        scale: "sm"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CoreTag */.eE, {
                                        scale: "sm"
                                    })
                                })
                            }, key);
                        case "details":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Details, {
                                            actionPanelToggled: actionPanelExpanded
                                        })
                                    })
                                })
                            }, key);
                        case "apr":
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                        label: t("APR"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Apr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.apr), {
                                            hideButton: isSmallerScreen
                                        }))
                                    })
                                })
                            }, key);
                        default:
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                        label: t(tableSchema[columnIndex].label),
                                        children: /*#__PURE__*/ (0,react.createElement)(cells[key], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props[key]), {
                                            userDataReady: userDataReady
                                        }))
                                    })
                                })
                            }, key);
                    }
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    style: {
                        cursor: "pointer"
                    },
                    onClick: toggleActionPanel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmMobileCell, {
                        colSpan: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Farm, (0,_object_spread/* default */.Z)({}, props.farm)),
                                props.type === "community" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* FarmAuctionTag */.Vi, {
                                    marginRight: "16px",
                                    scale: "sm"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CoreTag */.eE, {
                                    marginRight: "16px",
                                    scale: "sm"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTr, {
                    onClick: toggleActionPanel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EarnedMobileCell, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                    label: t("Earned"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Earned, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.earned), {
                                        userDataReady: userDataReady
                                    }))
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AprMobileCell, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_CellLayout, {
                                    label: t("APR"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Apr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.apr), {
                                        hideButton: true
                                    }))
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CellInner, {
                                style: {
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Details, {
                                    actionPanelToggled: actionPanelExpanded
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            handleRenderRow(),
            shouldRenderChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    colSpan: 7,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions_ActionPanel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        expanded: actionPanelExpanded
                    }))
                })
            })
        ]
    });
};
/* harmony default export */ var FarmTable_Row = (Row);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTable/FarmTable.tsx



function FarmTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n  border-radius: 16px;\n  margin: 16px 0px;\n  border: 1px solid ",
        ";\n"
    ]);
    FarmTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FarmTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n  scroll-margin-top: 64px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    FarmTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FarmTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-collapse: collapse;\n  font-size: 14px;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n"
    ]);
    FarmTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FarmTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & tr {\n    td {\n      font-size: 16px;\n      vertical-align: middle;\n    }\n  }\n"
    ]);
    FarmTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FarmTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    FarmTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FarmTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding-top: 5px;\n  padding-bottom: 5px;\n"
    ]);
    FarmTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var FarmTable_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11078fff-0"
})(FarmTable_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var TableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11078fff-1"
})(FarmTable_templateObject1());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-11078fff-2"
})(FarmTable_templateObject2());
var TableBody = styled_components_browser_esm/* default.tbody.withConfig */.ZP.tbody.withConfig({
    componentId: "sc-11078fff-3"
})(FarmTable_templateObject3());
var TableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11078fff-4"
})(FarmTable_templateObject4());
var ScrollButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11078fff-5"
})(FarmTable_templateObject5());
var FarmTable = function(param) {
    var farms = param.farms, wkdPrice = param.wkdPrice, userDataReady = param.userDataReady;
    var tableWrapperEl = (0,react.useRef)(null);
    var query = (0,next_router.useRouter)().query;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var columns = (0,react.useMemo)(function() {
        return DesktopColumnSchema.map(function(column) {
            return {
                id: column.id,
                name: column.name,
                label: column.label,
                sort: function(a, b) {
                    switch(column.name){
                        case "farm":
                            return b.id - a.id;
                        case "apr":
                            if (a.original.apr.value && b.original.apr.value) {
                                return Number(a.original.apr.value) - Number(b.original.apr.value);
                            }
                            return 0;
                        case "earned":
                            return a.original.earned.earnings - b.original.earned.earnings;
                        default:
                            return 1;
                    }
                },
                sortable: column.sortable
            };
        });
    }, []);
    var scrollToTop = (0,react.useCallback)(function() {
        window.scrollTo({
            top: tableWrapperEl.current.offsetTop,
            behavior: "smooth"
        });
    }, []);
    var rowData = farms.map(function(farm) {
        var token = farm.token, quoteToken = farm.quoteToken;
        var tokenAddress = token.address;
        var quoteTokenAddress = quoteToken.address;
        var lpLabel = farm.lpSymbol && farm.lpSymbol.split(" ")[0].toUpperCase().replace("PANCAKE", "");
        var lowercaseQuery = (0,latinise/* latinise */.b)(typeof (query === null || query === void 0 ? void 0 : query.search) === "string" ? query.search.toLowerCase() : "");
        var initialActivity = (0,latinise/* latinise */.b)(lpLabel === null || lpLabel === void 0 ? void 0 : lpLabel.toLowerCase()) === lowercaseQuery;
        var row = {
            apr: {
                value: (0,getDisplayApr/* getDisplayApr */.V)(farm.apr, farm.lpRewardsApr),
                pid: farm.pid,
                multiplier: farm.multiplier,
                lpLabel: lpLabel,
                lpSymbol: farm.lpSymbol,
                tokenAddress: tokenAddress,
                quoteTokenAddress: quoteTokenAddress,
                wkdPrice: wkdPrice,
                originalValue: farm.apr
            },
            farm: {
                label: lpLabel,
                pid: farm.pid,
                token: farm.token,
                quoteToken: farm.quoteToken
            },
            earned: {
                // eslint-disable-next-line spaced-comment
                earnings: (0,formatBalance/* getBalanceNumber */.mW)(new (bignumber_default())(farm.userData.earnings), 9),
                pid: farm.pid
            },
            liquidity: {
                liquidity: farm.liquidity
            },
            multiplier: {
                multiplier: farm.multiplier
            },
            type: farm.isCommunity ? "community" : "core",
            details: farm,
            initialActivity: initialActivity
        };
        return row;
    });
    var sortedRows = rowData.map(function(row) {
        // @ts-ignore
        var newRow = {};
        columns.forEach(function(column) {
            if (!(column.name in row)) {
                throw new Error("Invalid row data, ".concat(column.name, " not found"));
            }
            newRow[column.name] = row[column.name];
        });
        newRow.initialActivity = row.initialActivity;
        return newRow;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_Container, {
        id: "farms-table",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableContainer, {
            id: "table-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrapper, {
                    ref: tableWrapperEl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTable, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody, {
                            children: sortedRows.map(function(row) {
                                return /*#__PURE__*/ (0,react.createElement)(FarmTable_Row, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, row), {
                                    userDataReady: userDataReady,
                                    key: "table-row-".concat(row.farm.pid)
                                }));
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        variant: "text",
                        onClick: scrollToTop,
                        children: [
                            t("To Top"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {
                                color: "primary"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FarmTable_FarmTable = (FarmTable);

// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(45341);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(53629);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmTabButtons/index.tsx

function FarmTabButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    FarmTabButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var FarmTabButtons = function(param) {
    var hasStakeInFinishedFarms = param.hasStakeInFinishedFarms;
    var router = (0,next_router.useRouter)();
    var t = (0,Localization/* useTranslation */.$G)().t;
    var activeIndex;
    switch(router.pathname){
        case "/farms":
            activeIndex = 0;
            break;
        case "/farms/history":
            activeIndex = 1;
            break;
        case "/_mp/farms/history":
            activeIndex = 1;
            break;
        case "/farms/archived":
            activeIndex = 2;
            break;
        default:
            activeIndex = 0;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
            activeIndex: activeIndex,
            scale: "sm",
            variant: "subtle",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                    as: NextLink/* NextLinkFromReactRouter */.a,
                    to: "/farms",
                    children: t("Live")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                    show: hasStakeInFinishedFarms,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        as: NextLink/* NextLinkFromReactRouter */.a,
                        to: "/farms/history",
                        id: "finished-farms-button",
                        children: t("Finished")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_FarmTabButtons = (FarmTabButtons);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9f5cb7a-0"
})(FarmTabButtons_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});

;// CONCATENATED MODULE: ./src/views/Farms/Farms.tsx




function Farms_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  position: relative;\n\n  justify-content: space-between;\n  flex-direction: column;\n  margin-bottom: 32px;\n\n  ",
        " {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 16px 32px;\n    margin-bottom: 0;\n  }\n"
    ]);
    Farms_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Farms_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n\n  ",
        " {\n    margin-left: 8px;\n  }\n"
    ]);
    Farms_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Farms_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > ",
        " {\n    font-size: 12px;\n  }\n"
    ]);
    Farms_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Farms_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0px;\n\n  ",
        " {\n    width: auto;\n    padding: 0;\n  }\n"
    ]);
    Farms_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Farms_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  > div {\n    padding: 8px 0px;\n  }\n\n  ",
        " {\n    justify-content: flex-start;\n    width: auto;\n\n    > div {\n      padding: 0;\n    }\n  }\n"
    ]);
    Farms_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Farms_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 58px;\n"
    ]);
    Farms_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Farms_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 32px;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    Farms_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Farms_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  white-space: nowrap;\n  text-decoration: underline;\n"
    ]);
    Farms_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

























var ControlContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ab6207e-0"
})(Farms_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ToggleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ab6207e-1"
})(Farms_templateObject1(), Text/* default */.Z);
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ab6207e-2"
})(Farms_templateObject2(), Text/* default */.Z);
var FilterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ab6207e-3"
})(Farms_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ViewControls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ab6207e-4"
})(Farms_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-8ab6207e-5"
})(Farms_templateObject5());
var FinishedTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8ab6207e-6"
})(Farms_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FinishedTextLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-8ab6207e-7"
})(Farms_templateObject7());
var NUMBER_OF_FARMS_VISIBLE = 12;
var Farms = function(param) {
    var children = param.children;
    var ref = (0,next_router.useRouter)(), pathname = ref.pathname, urlQuery = ref.query;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref1 = (0,hooks/* useFarms */.E2)(), farmsLP = ref1.data, userDataLoaded = ref1.userDataLoaded, poolLength = ref1.poolLength, regularWkdPerBlock = ref1.regularWkdPerBlock;
    var wkdPrice = (0,hooks/* usePriceWkdBusd */.ek)();
    var ref2 = (0,react.useState)(""), _query = ref2[0], setQuery = ref2[1];
    var normalizedUrlSearch = (0,react.useMemo)(function() {
        return typeof (urlQuery === null || urlQuery === void 0 ? void 0 : urlQuery.search) === "string" ? urlQuery.search : "";
    }, [
        urlQuery
    ]);
    var query = normalizedUrlSearch && !_query ? normalizedUrlSearch : _query;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserFarmsViewMode */.y9)(), 2), viewMode = ref3[0], setViewMode = ref3[1];
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref4 = (0,react.useState)("hot"), sortOption = ref4[0], setSortOption = ref4[1];
    var ref5 = (0,useIntersectionObserver/* default */.Z)(), observerRef = ref5.observerRef, isIntersecting = ref5.isIntersecting;
    var chosenFarmsLength = (0,react.useRef)(0);
    var isArchived = pathname.includes("archived");
    var isInactive = pathname.includes("history");
    var isActive = !isInactive && !isArchived;
    (0,hooks/* usePollFarmsWithUserData */.Cs)();
    // Users with no wallet connected should see 0 as Earned amount
    // Connected users should see loading indicator until first userData has loaded
    var userDataReady = !account || !!account && userDataLoaded;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserFarmStakedOnly */.XD)(isActive), 2), stakedOnly = ref6[0], setStakedOnly = ref6[1];
    // const activeFarms = farmsLP.filter(
    //   (farm) => farm.pid !== 0 && farm.multiplier !== '0X' && (!poolLength || poolLength > farm.pid),
    // )
    var activeFarms = farmsLP.filter(function(farm) {
        return farm.multiplier !== "0X" && (!poolLength || poolLength > farm.pid);
    });
    var inactiveFarms = farmsLP.filter(function(farm) {
        return farm.pid !== 0 && farm.multiplier === "0X";
    });
    var archivedFarms = farmsLP;
    var stakedOnlyFarms = activeFarms.filter(function(farm) {
        return farm.userData && new (bignumber_default())(farm.userData.stakedBalance).isGreaterThan(0);
    });
    var stakedInactiveFarms = inactiveFarms.filter(function(farm) {
        return farm.userData && new (bignumber_default())(farm.userData.stakedBalance).isGreaterThan(0);
    });
    var stakedArchivedFarms = archivedFarms.filter(function(farm) {
        return farm.userData && new (bignumber_default())(farm.userData.stakedBalance).isGreaterThan(0);
    });
    var farmsList = (0,react.useCallback)(function(farmsToDisplay) {
        var farmsToDisplayWithAPR = farmsToDisplay.map(function(farm) {
            if (!farm.lpTotalInQuoteToken || !farm.quoteTokenPriceBusd) {
                return farm;
            }
            var totalLiquidity = new (bignumber_default())(farm.lpTotalInQuoteToken).times(farm.quoteTokenPriceBusd);
            var ref = isActive ? (0,apr/* getFarmApr */.yW)(new (bignumber_default())(farm.poolWeight), wkdPrice, totalLiquidity, farm.lpAddresses[src/* ChainId.BSC */.a_.BSC], regularWkdPerBlock) : {
                wkdRewardsApr: 0,
                lpRewardsApr: 0
            }, wkdRewardsApr = ref.wkdRewardsApr, lpRewardsApr = ref.lpRewardsApr;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                apr: wkdRewardsApr,
                lpRewardsApr: lpRewardsApr,
                liquidity: totalLiquidity
            });
        });
        if (query) {
            var lowercaseQuery = (0,latinise/* latinise */.b)(query.toLowerCase());
            farmsToDisplayWithAPR = farmsToDisplayWithAPR.filter(function(farm) {
                return (0,latinise/* latinise */.b)(farm.lpSymbol.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return farmsToDisplayWithAPR;
    }, [
        wkdPrice,
        query,
        isActive,
        regularWkdPerBlock
    ]);
    var handleChangeQuery = function(event) {
        setQuery(event.target.value);
    };
    var ref7 = (0,react.useState)(NUMBER_OF_FARMS_VISIBLE), numberOfFarmsVisible = ref7[0], setNumberOfFarmsVisible = ref7[1];
    var chosenFarmsMemoized = (0,react.useMemo)(function() {
        var chosenFarms = [];
        var sortFarms = function(farms) {
            switch(sortOption){
                case "apr":
                    return orderBy_default()(farms, function(farm) {
                        return farm.apr + farm.lpRewardsApr;
                    }, "desc");
                case "multiplier":
                    return orderBy_default()(farms, function(farm) {
                        return farm.multiplier ? Number(farm.multiplier.slice(0, -1)) : 0;
                    }, "desc");
                case "earned":
                    return orderBy_default()(farms, function(farm) {
                        return farm.userData ? Number(farm.userData.earnings) : 0;
                    }, "desc");
                case "liquidity":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.liquidity);
                    }, "desc");
                case "latest":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.pid);
                    }, "desc");
                default:
                    return farms;
            }
        };
        if (isActive) {
            chosenFarms = stakedOnly ? farmsList(stakedOnlyFarms) : farmsList(activeFarms);
        }
        if (isInactive) {
            chosenFarms = stakedOnly ? farmsList(stakedInactiveFarms) : farmsList(inactiveFarms);
        }
        if (isArchived) {
            chosenFarms = stakedOnly ? farmsList(stakedArchivedFarms) : farmsList(archivedFarms);
        }
        return sortFarms(chosenFarms).slice(0, numberOfFarmsVisible);
    }, [
        sortOption,
        activeFarms,
        farmsList,
        inactiveFarms,
        archivedFarms,
        isActive,
        isInactive,
        isArchived,
        stakedArchivedFarms,
        stakedInactiveFarms,
        stakedOnly,
        stakedOnlyFarms,
        numberOfFarmsVisible, 
    ]);
    chosenFarmsLength.current = chosenFarmsMemoized.length;
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setNumberOfFarmsVisible(function(farmsCurrentlyVisible) {
                if (farmsCurrentlyVisible <= chosenFarmsLength.current) {
                    return farmsCurrentlyVisible + NUMBER_OF_FARMS_VISIBLE;
                }
                return farmsCurrentlyVisible;
            });
        }
    }, [
        isIntersecting
    ]);
    var handleSortOptionChange = function(option) {
        setSortOption(option.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmsContext.Provider, {
        value: {
            chosenFarmsMemoized: chosenFarmsMemoized
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageHeader/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h1",
                        scale: "xxl",
                        color: "secondary",
                        mb: "24px",
                        children: t("Farms")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        color: "text",
                        children: t("Stake LP tokens to earn.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ControlContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewControls, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleView/* default */.Z, {
                                        idPrefix: "clickFarm",
                                        viewMode: viewMode,
                                        onToggle: setViewMode
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                                id: "staked-only-farms",
                                                checked: stakedOnly,
                                                onChange: function() {
                                                    return setStakedOnly(!stakedOnly);
                                                },
                                                scale: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    " ",
                                                    t("Staked only")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FarmTabButtons, {
                                        hasStakeInFinishedFarms: stakedInactiveFarms.length > 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textTransform: "uppercase",
                                                children: t("Sort by")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                options: [
                                                    {
                                                        label: t("Hot"),
                                                        value: "hot"
                                                    },
                                                    {
                                                        label: t("APR"),
                                                        value: "apr"
                                                    },
                                                    {
                                                        label: t("Multiplier"),
                                                        value: "multiplier"
                                                    },
                                                    {
                                                        label: t("Earned"),
                                                        value: "earned"
                                                    },
                                                    {
                                                        label: t("Liquidity"),
                                                        value: "liquidity"
                                                    },
                                                    {
                                                        label: t("Latest"),
                                                        value: "latest"
                                                    }, 
                                                ],
                                                onOptionChange: handleSortOptionChange
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        style: {
                                            marginLeft: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textTransform: "uppercase",
                                                children: t("Search")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                                                initialValue: normalizedUrlSearch,
                                                onChange: handleChangeQuery,
                                                placeholder: "Search Farms"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isInactive && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishedTextContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: [
                                "16px",
                                null,
                                "20px"
                            ],
                            color: "failure",
                            textAlign: "center",
                            mx: "auto",
                            children: t("No Finished farm")
                        })
                    }),
                    viewMode === actions/* ViewMode.TABLE */.wO.TABLE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTable_FarmTable, {
                        farms: chosenFarmsMemoized,
                        wkdPrice: wkdPrice,
                        userDataReady: userDataReady
                    }) : // <Text textAlign="center" mx="auto">
                    //   Coming soon...
                    // </Text>
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Flex/* default */.Z, {
                        children: children
                    }),
                    account && !userDataLoaded && stakedOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: observerRef
                    })
                ]
            })
        ]
    });
};
var FarmsContext = /*#__PURE__*/ (0,react.createContext)({
    chosenFarmsMemoized: []
});
/* harmony default export */ var Farms_Farms = (Farms);


/***/ }),

/***/ 37272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5527);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47509);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(84091);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19729);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(10566);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3725);
/* harmony import */ var components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61102);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99150);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65044);
/* harmony import */ var utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43452);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  width: 72px;\n  max-width: 72px;\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var AnnualRoiContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd9cce4f-0"
})(_templateObject());
var AnnualRoiDisplay = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd9cce4f-1"
})(_templateObject1());
var DepositModal = function(param) {
    var max = param.max, stakedBalance = param.stakedBalance, onConfirm = param.onConfirm, onDismiss = param.onDismiss, _tokenName = param.tokenName, tokenName = _tokenName === void 0 ? "" : _tokenName, multiplier = param.multiplier, displayApr = param.displayApr, lpPrice = param.lpPrice, _lpLabel = param.lpLabel, lpLabel = _lpLabel === void 0 ? "" : _lpLabel, apr = param.apr, addLiquidityUrl = param.addLiquidityUrl, wkdPrice = param.wkdPrice;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), val = ref[0], setVal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showRoiCalculator = ref2[0], setShowRoiCalculator = ref2[1];
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)().t;
    var fullBalance = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_8__/* .getFullDisplayBalance */ .NJ)(max);
    }, [
        max
    ]);
    var lpTokensToStake = new (bignumber_js__WEBPACK_IMPORTED_MODULE_3___default())(val);
    var fullBalanceNumber = new (bignumber_js__WEBPACK_IMPORTED_MODULE_3___default())(fullBalance);
    var usdToStake = lpTokensToStake.times(lpPrice);
    var interestBreakdown = (0,utils_compoundApyHelpers__WEBPACK_IMPORTED_MODULE_12__/* .getInterestBreakdown */ .A1)({
        principalInUSD: !lpTokensToStake.isNaN() ? usdToStake.toNumber() : 0,
        apr: apr,
        earningTokenPrice: wkdPrice.toNumber()
    });
    var annualRoi = wkdPrice.times(interestBreakdown[3]);
    var annualRoiAsNumber = annualRoi.toNumber();
    var formattedAnnualRoi = (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_8__/* .formatNumber */ .uf)(annualRoiAsNumber, annualRoi.gt(10000) ? 0 : 2, annualRoi.gt(10000) ? 0 : 2);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(e) {
        if (e.currentTarget.validity.valid) {
            setVal(e.currentTarget.value.replace(/,/g, "."));
        }
    }, [
        setVal
    ]);
    var handleSelectMax = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setVal(fullBalance);
    }, [
        fullBalance,
        setVal
    ]);
    if (showRoiCalculator) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            linkLabel: t("Get %symbol%", {
                symbol: lpLabel
            }),
            stakingTokenBalance: stakedBalance.plus(max),
            stakingTokenSymbol: tokenName,
            stakingTokenPrice: lpPrice.toNumber(),
            earningTokenPrice: wkdPrice.toNumber(),
            apr: apr,
            multiplier: multiplier,
            displayApr: displayApr,
            linkHref: addLiquidityUrl,
            isFarm: true,
            initialValue: val,
            onBack: function() {
                return setShowRoiCalculator(false);
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        title: t("Stake LP tokens"),
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalInput */ .S, {
                value: val,
                onSelectMax: handleSelectMax,
                onChange: handleChange,
                max: fullBalance,
                symbol: tokenName,
                addLiquidityUrl: addLiquidityUrl,
                inputTitle: t("Stake")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                mt: "24px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        mr: "8px",
                        color: "textSubtle",
                        children: [
                            t("Annual ROI at current rates"),
                            ":"
                        ]
                    }),
                    Number.isFinite(annualRoiAsNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnnualRoiContainer, {
                        alignItems: "center",
                        onClick: function() {
                            setShowRoiCalculator(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnnualRoiDisplay, {
                                children: [
                                    "$",
                                    formattedAnnualRoi
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "text",
                                scale: "sm",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    color: "textSubtle",
                                    width: "18px"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        width: 60
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_Modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalActions */ .n, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        variant: "secondary",
                        onClick: onDismiss,
                        width: "100%",
                        disabled: pendingTx,
                        children: t("Cancel")
                    }),
                    pendingTx ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        width: "100%",
                        isLoading: pendingTx,
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            spin: true,
                            color: "currentColor"
                        }),
                        children: t("Confirming")
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        width: "100%",
                        disabled: !lpTokensToStake.isFinite() || lpTokensToStake.eq(0) || lpTokensToStake.gt(fullBalanceNumber),
                        onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        setPendingTx(true);
                                        _ctx.next = 3;
                                        return onConfirm(val);
                                    case 3:
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                        setPendingTx(false);
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: t("Confirm")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                href: addLiquidityUrl,
                style: {
                    alignSelf: "center"
                },
                children: t("Get %symbol%", {
                    symbol: tokenName
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DepositModal);


/***/ }),

/***/ 75313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65528);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5527);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47509);
/* harmony import */ var components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61102);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99150);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17166);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ApyLabelContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b78e2c18-0"
})(_templateObject());
var ApyButton = function(param) {
    var variant = param.variant, pid = param.pid, lpLabel = param.lpLabel, lpSymbol = param.lpSymbol, wkdPrice = param.wkdPrice, apr = param.apr, multiplier = param.multiplier, displayApr = param.displayApr, addLiquidityUrl = param.addLiquidityUrl;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var lpPrice = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useLpTokenPrice */ .w5)(lpSymbol);
    var ref = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useFarmUser */ .Dx)(pid), tokenBalance = ref.tokenBalance, stakedBalance = ref.stakedBalance;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_RoiCalculatorModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        linkLabel: t("Get %symbol%", {
            symbol: lpLabel
        }),
        stakingTokenBalance: stakedBalance.plus(tokenBalance),
        stakingTokenSymbol: lpSymbol,
        stakingTokenPrice: lpPrice.toNumber(),
        earningTokenPrice: wkdPrice === null || wkdPrice === void 0 ? void 0 : wkdPrice.toNumber(),
        apr: apr,
        multiplier: multiplier,
        displayApr: displayApr,
        linkHref: addLiquidityUrl,
        isFarm: true
    })), 1), onPresentApyModal = ref1[0];
    var handleClickButton = function(event) {
        event.stopPropagation();
        onPresentApyModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ApyLabelContainer, {
        alignItems: "center",
        onClick: handleClickButton,
        children: [
            displayApr,
            "%",
            variant === "text-and-button" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                variant: "text",
                scale: "sm",
                ml: "4px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    width: "18px"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ApyButton);


/***/ }),

/***/ 91774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FarmCard_FarmCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(40447);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/ExpandableSectionButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ff226e31-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ExpandableSectionButton = function(param) {
    var onClick = param.onClick, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var handleOnClick = (0,react.useCallback)(function() {
        return onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        "aria-label": t("Hide or show expandable content"),
        role: "button",
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "primary",
                bold: true,
                children: expanded ? t("Hide") : t("Details")
            }),
            expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ExpandableSectionButton_ExpandableSectionButton = (ExpandableSectionButton);

;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/index.ts


// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(37519);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
// EXTERNAL MODULE: ./src/utils/getLiquidityUrlPathParts.ts
var getLiquidityUrlPathParts = __webpack_require__(51912);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/DetailsSection.tsx

function DetailsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n"
    ]);
    DetailsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var DetailsSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eb9f68d-0"
})(DetailsSection_templateObject());
var StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-5eb9f68d-1"
})(_templateObject1());
var DetailsSection = function(param) {
    var bscScanAddress = param.bscScanAddress, infoAddress = param.infoAddress, removed = param.removed, totalValueFormatted = param.totalValueFormatted, lpLabel = param.lpLabel, addLiquidityUrl = param.addLiquidityUrl, isCommunity = param.isCommunity, auctionHostingEndDate = param.auctionHostingEndDate;
    var ref = (0,Localization/* useTranslation */.$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsSection_Wrapper, {
        children: [
            isCommunity && auctionHostingEndDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            t("Auction Hosting Ends"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: new Date(auctionHostingEndDate).toLocaleString(locale, {
                            month: "short",
                            day: "numeric",
                            year: "numeric"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        children: [
                            t("Total Liquidity"),
                            ":"
                        ]
                    }),
                    totalValueFormatted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: totalValueFormatted
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: 75,
                        height: 25
                    })
                ]
            }),
            !removed && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                href: addLiquidityUrl,
                children: t("Get %symbol%", {
                    symbol: lpLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                href: bscScanAddress,
                children: t("View Contract")
            })
        ]
    });
};
/* harmony default export */ var FarmCard_DetailsSection = (DetailsSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(24930);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/components/Tags.tsx
var Tags = __webpack_require__(69160);
// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(95239);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/CardHeading.tsx

function CardHeading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    margin-right: 4px;\n  }\n"
    ]);
    CardHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardHeading_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n"
    ]);
    CardHeading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var CardHeading_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7b186e87-0"
})(CardHeading_templateObject());
var MultiplierTag = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-7b186e87-1"
})(CardHeading_templateObject1());
var CardHeading = function(param) {
    var lpLabel = param.lpLabel, multiplier = param.multiplier, isCommunityFarm = param.isCommunityFarm, token = param.token, quoteToken = param.quoteToken;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeading_Wrapper, {
        justifyContent: "space-between",
        alignItems: "center",
        mb: "12px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                variant: "inverted",
                primaryToken: token,
                secondaryToken: quoteToken,
                width: 64,
                height: 64
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "4px",
                        children: lpLabel.split(" ")[0]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: [
                            isCommunityFarm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* FarmAuctionTag */.Vi, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags/* CoreTag */.eE, {}),
                            multiplier ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiplierTag, {
                                variant: "primary",
                                children: multiplier
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmCard_CardHeading = (CardHeading);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(71418);
// EXTERNAL MODULE: ./src/state/index.ts + 36 modules
var state = __webpack_require__(84143);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 1 modules
var farms = __webpack_require__(36393);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useApproveFarm.ts
var useApproveFarm = __webpack_require__(76807);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var hooks = __webpack_require__(17166);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useHarvestFarm.ts
var useHarvestFarm = __webpack_require__(86507);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/HarvestAction.tsx

















var HarvestAction = function(param) {
    var earnings = param.earnings, pid = param.pid;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var onReward = (0,useHarvestFarm/* default */.Z)(pid).onReward;
    var wkdPrice = (0,hooks/* usePriceWkdBusd */.ek)();
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var rawEarningsBalance = account ? (0,formatBalance/* getBalanceAmount */.U4)(earnings, 9) : bigNumber/* BIG_ZERO */.HW;
    var displayBalance = rawEarningsBalance.toFixed(3, (bignumber_default()).ROUND_DOWN);
    var earningsBusd = rawEarningsBalance ? rawEarningsBalance.multipliedBy(wkdPrice).toNumber() : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        mb: "8px",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        color: rawEarningsBalance.eq(0) ? "textDisabled" : "text",
                        children: displayBalance
                    }),
                    earningsBusd > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        decimals: 2,
                        value: earningsBusd,
                        unit: " USD",
                        prefix: "~"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                disabled: rawEarningsBalance.eq(0) || pendingTx,
                onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var receipt;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return fetchWithCatchTxError(function() {
                                    return onReward();
                                });
                            case 2:
                                receipt = _ctx.sent;
                                if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                    toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                        txHash: receipt.transactionHash,
                                        children: t("Your %symbol% earnings have been sent to your wallet!", {
                                            symbol: "WKD"
                                        })
                                    }));
                                    dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                        account: account,
                                        pids: [
                                            pid
                                        ]
                                    }));
                                }
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                children: pendingTx ? t("Harvesting") : t("Harvest")
            })
        ]
    });
};
/* harmony default export */ var FarmCard_HarvestAction = (HarvestAction);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(72943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/views/Farms/components/DepositModal.tsx
var DepositModal = __webpack_require__(37272);
// EXTERNAL MODULE: ./src/views/Farms/components/WithdrawModal.tsx
var WithdrawModal = __webpack_require__(71154);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useUnstakeFarms.ts
var useUnstakeFarms = __webpack_require__(97321);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useStakeFarms.ts
var useStakeFarms = __webpack_require__(60508);
// EXTERNAL MODULE: ./src/views/Farms/components/StakedLP.tsx
var StakedLP = __webpack_require__(58660);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/StakeAction.tsx




function StakeAction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  svg {\n    width: 20px;\n  }\n"
    ]);
    StakeAction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var IconButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e3860c4-0"
})(StakeAction_templateObject());
var StakeAction = function(param) {
    var quoteToken = param.quoteToken, token = param.token, lpSymbol = param.lpSymbol, pid = param.pid, multiplier = param.multiplier, apr = param.apr, displayApr = param.displayApr, addLiquidityUrl = param.addLiquidityUrl, lpLabel = param.lpLabel, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var onStake = (0,useStakeFarms/* default */.Z)(pid).onStake;
    var onUnstake = (0,useUnstakeFarms/* default */.Z)(pid).onUnstake;
    var ref = (0,hooks/* useFarmUser */.Dx)(pid), tokenBalance = ref.tokenBalance, stakedBalance = ref.stakedBalance;
    var wkdPrice = (0,hooks/* usePriceWkdBusd */.ek)();
    var router = (0,next_router.useRouter)();
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var lpPrice = (0,hooks/* useLpTokenPrice */.w5)(lpSymbol);
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var fetchWithCatchTxError = (0,useCatchTxError/* default */.Z)().fetchWithCatchTxError;
    var handleStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onStake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Staked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your funds have been staked in the farm")
                            }));
                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                account: account,
                                pids: [
                                    pid
                                ]
                            }));
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleStake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnstake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amount) {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onUnstake(amount);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Unstaked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your earnings have also been harvested to your wallet")
                            }));
                            dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                                account: account,
                                pids: [
                                    pid
                                ]
                            }));
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnstake(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DepositModal/* default */.Z, {
        max: tokenBalance,
        stakedBalance: stakedBalance,
        onConfirm: handleStake,
        tokenName: lpSymbol,
        multiplier: multiplier,
        lpPrice: lpPrice,
        lpLabel: lpLabel,
        apr: apr,
        displayApr: displayApr,
        addLiquidityUrl: addLiquidityUrl,
        wkdPrice: wkdPrice
    })), 1), onPresentDeposit = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawModal/* default */.Z, {
        max: stakedBalance,
        onConfirm: handleUnstake,
        tokenName: lpSymbol
    })), 1), onPresentWithdraw = ref2[0];
    var renderStakingButtons = function() {
        return stakedBalance.eq(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: onPresentDeposit,
            disabled: [
                "history",
                "archived"
            ].some(function(item) {
                return router.pathname.includes(item);
            }),
            children: t("Stake LP")
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButtonWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    variant: "tertiary",
                    onClick: onPresentWithdraw,
                    mr: "6px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                        color: "primary",
                        width: "14px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    variant: "tertiary",
                    onClick: onPresentDeposit,
                    disabled: [
                        "history",
                        "archived"
                    ].some(function(item) {
                        return router.pathname.includes(item);
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                        color: "primary",
                        width: "14px"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakedLP/* default */.Z, {
                stakedBalance: stakedBalance,
                lpSymbol: lpSymbol,
                quoteTokenSymbol: quoteToken.symbol,
                tokenSymbol: token.symbol,
                lpTotalSupply: lpTotalSupply,
                tokenAmountTotal: tokenAmountTotal,
                quoteTokenAmountTotal: quoteTokenAmountTotal
            }),
            renderStakingButtons()
        ]
    });
};
/* harmony default export */ var FarmCard_StakeAction = (StakeAction);

;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/CardActionsContainer.tsx





function CardActionsContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n"
    ]);
    CardActionsContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var Action = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9d431981-0"
})(CardActionsContainer_templateObject());
var CardActions = function(param) {
    var farm = param.farm, account = param.account, addLiquidityUrl = param.addLiquidityUrl, lpLabel = param.lpLabel, displayApr = param.displayApr;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref.fetchWithCatchTxError, pendingTx = ref.loading;
    var pid = farm.pid, lpAddresses = farm.lpAddresses;
    var ref1 = farm.userData || {}, allowance = ref1.allowance, earnings = ref1.earnings;
    var lpAddress = (0,addressHelpers/* getAddress */.Kn)(lpAddresses);
    var isApproved = account && allowance && allowance.isGreaterThan(0);
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var lpContract = (0,useContract/* useERC20 */.X_)(lpAddress);
    var onApprove = (0,useApproveFarm/* default */.Z)(lpContract).onApprove;
    var handleApprove = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var receipt;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetchWithCatchTxError(function() {
                        return onApprove();
                    });
                case 2:
                    receipt = _ctx.sent;
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: receipt.transactionHash
                        }));
                        dispatch((0,farms/* fetchFarmUserDataAsync */.IV)({
                            account: account,
                            pids: [
                                pid
                            ]
                        }));
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        onApprove,
        dispatch,
        account,
        pid,
        t,
        toastSuccess,
        fetchWithCatchTxError
    ]);
    var renderApprovalOrStakeButton = function() {
        return isApproved ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_StakeAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
            lpLabel: lpLabel,
            addLiquidityUrl: addLiquidityUrl,
            displayApr: displayApr
        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            mt: "8px",
            width: "100%",
            disabled: pendingTx,
            onClick: handleApprove,
            children: t("Enable Contract")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Action, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "secondary",
                        fontSize: "12px",
                        pr: "4px",
                        children: "WKD"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Earned")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_HarvestAction, {
                earnings: earnings,
                pid: pid
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "secondary",
                        fontSize: "12px",
                        pr: "4px",
                        children: farm.lpSymbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        textTransform: "uppercase",
                        color: "textSubtle",
                        fontSize: "12px",
                        children: t("Staked")
                    })
                ]
            }),
            !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                mt: "8px",
                width: "100%"
            }) : renderApprovalOrStakeButton()
        ]
    });
};
/* harmony default export */ var CardActionsContainer = (CardActions);

// EXTERNAL MODULE: ./src/views/Farms/components/FarmCard/ApyButton.tsx
var ApyButton = __webpack_require__(75313);
;// CONCATENATED MODULE: ./src/views/Farms/components/FarmCard/FarmCard.tsx

function FarmCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: baseline;\n  max-width: 100%;\n  margin: 0 0 24px 0;\n  ",
        " {\n    max-width: 350px;\n    margin: 0 12px 46px;\n  }\n"
    ]);
    FarmCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FarmCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 24px;\n"
    ]);
    FarmCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  border-top: 2px solid ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-adb8b27e-0"
})(FarmCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FarmCardInnerContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-adb8b27e-1"
})(FarmCard_templateObject1());
var ExpandingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adb8b27e-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var FarmCard = function(param) {
    var farm = param.farm, displayApr = param.displayApr, removed = param.removed, wkdPrice = param.wkdPrice, account = param.account;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), showExpandableSection = ref[0], setShowExpandableSection = ref[1];
    var totalValueFormatted = farm.liquidity && farm.liquidity.gt(0) ? "$".concat(farm.liquidity.toNumber().toLocaleString(undefined, {
        maximumFractionDigits: 0
    })) : "";
    var lpLabel = farm.lpSymbol && farm.lpSymbol.toUpperCase().replace("PANCAKE", "");
    // const earnLabel = farm.dual ? farm.dual.earnLabel : t('CAKE + Fees')
    var earnLabel = farm.dual ? farm.dual.earnLabel : t("WKD");
    var liquidityUrlPathParts = (0,getLiquidityUrlPathParts/* default */.Z)({
        quoteTokenAddress: farm.quoteToken.address,
        tokenAddress: farm.token.address
    });
    var addLiquidityUrl = "".concat(config/* BASE_ADD_LIQUIDITY_URL */.wI, "/").concat(liquidityUrlPathParts);
    var lpAddress = (0,addressHelpers/* getAddress */.Kn)(farm.lpAddresses);
    var isPromotedFarm = farm.token.symbol === "CAKE";
    var toggleExpandableSection = (0,react.useCallback)(function() {
        setShowExpandableSection(function(prev) {
            return !prev;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        isActive: isPromotedFarm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FarmCardInnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_CardHeading, {
                        lpLabel: lpLabel,
                        multiplier: farm.multiplier,
                        isCommunityFarm: farm.isCommunity,
                        token: farm.token,
                        quoteToken: farm.quoteToken
                    }),
                    !removed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    t("APY"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: farm.apr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApyButton/* default */.Z, {
                                    variant: "text-and-button",
                                    pid: farm.pid,
                                    lpSymbol: farm.lpSymbol,
                                    multiplier: farm.multiplier,
                                    lpLabel: lpLabel,
                                    addLiquidityUrl: addLiquidityUrl,
                                    wkdPrice: wkdPrice,
                                    apr: farm.apr,
                                    displayApr: displayApr
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    height: 24,
                                    width: 80
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    t("Earn"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                children: earnLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionsContainer, {
                        farm: farm,
                        lpLabel: lpLabel,
                        account: account,
                        addLiquidityUrl: addLiquidityUrl,
                        displayApr: displayApr
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandingWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableSectionButton_ExpandableSectionButton, {
                        onClick: toggleExpandableSection,
                        expanded: showExpandableSection
                    }),
                    showExpandableSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCard_DetailsSection, {
                        removed: removed,
                        bscScanAddress: (0,utils/* getBscScanLink */.s6)(lpAddress, "address"),
                        infoAddress: "/info/pool/".concat(lpAddress),
                        totalValueFormatted: totalValueFormatted,
                        lpLabel: lpLabel,
                        addLiquidityUrl: addLiquidityUrl,
                        isCommunity: farm.isCommunity,
                        auctionHostingEndDate: farm.auctionHostingEndDate
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FarmCard_FarmCard = (FarmCard);


/***/ }),

/***/ 58660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59750);
/* harmony import */ var components_Balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20922);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17166);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65044);






var StakedLP = function(param) {
    var stakedBalance = param.stakedBalance, lpSymbol = param.lpSymbol, quoteTokenSymbol = param.quoteTokenSymbol, tokenSymbol = param.tokenSymbol, lpTotalSupply = param.lpTotalSupply, tokenAmountTotal = param.tokenAmountTotal, quoteTokenAmountTotal = param.quoteTokenAmountTotal;
    var lpPrice = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useLpTokenPrice */ .w5)(lpSymbol);
    var displayBalance = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .formatLpBalance */ .O$)(stakedBalance);
    }, [
        stakedBalance
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        flexDirection: "column",
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                color: stakedBalance.eq(0) ? "textDisabled" : "text",
                children: displayBalance
            }),
            stakedBalance.gt(0) && lpPrice.gt(0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        fontSize: "12px",
                        color: "textSubtle",
                        decimals: 2,
                        value: (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_4__/* .getBalanceNumber */ .mW)(lpPrice.times(stakedBalance)),
                        unit: " USD",
                        prefix: "~"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        style: {
                            gap: "4px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: stakedBalance.div(lpTotalSupply).times(tokenAmountTotal).toNumber(),
                                unit: " ".concat(tokenSymbol)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Balance__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                value: stakedBalance.div(lpTotalSupply).times(quoteTokenAmountTotal).toNumber(),
                                unit: " ".concat(quoteTokenSymbol)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StakedLP);


/***/ }),

/***/ 71154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19729);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3725);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99150);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65044);









var WithdrawModal = function(param) {
    var onConfirm = param.onConfirm, onDismiss = param.onDismiss, max = param.max, _tokenName = param.tokenName, tokenName = _tokenName === void 0 ? "" : _tokenName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), val = ref[0], setVal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var fullBalance = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_6__/* .getFullDisplayBalance */ .NJ)(max);
    }, [
        max
    ]);
    var valNumber = new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(val);
    var fullBalanceNumber = new (bignumber_js__WEBPACK_IMPORTED_MODULE_2___default())(fullBalance);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(e) {
        if (e.currentTarget.validity.valid) {
            setVal(e.currentTarget.value.replace(/,/g, "."));
        }
    }, [
        setVal
    ]);
    var handleSelectMax = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        setVal(fullBalance);
    }, [
        fullBalance,
        setVal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        title: t("Unstake LP tokens"),
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_4__/* .ModalInput */ .S, {
                onSelectMax: handleSelectMax,
                onChange: handleChange,
                value: val,
                max: fullBalance,
                symbol: tokenName,
                inputTitle: t("Unstake")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Modal__WEBPACK_IMPORTED_MODULE_4__/* .ModalActions */ .n, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        variant: "secondary",
                        onClick: onDismiss,
                        width: "100%",
                        disabled: pendingTx,
                        children: t("Cancel")
                    }),
                    pendingTx ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        width: "100%",
                        isLoading: pendingTx,
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            spin: true,
                            color: "currentColor"
                        }),
                        children: t("Confirming")
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        width: "100%",
                        disabled: !valNumber.isFinite() || valNumber.eq(0) || valNumber.gt(fullBalanceNumber),
                        onClick: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        setPendingTx(true);
                                        _ctx.next = 3;
                                        return onConfirm(val);
                                    case 3:
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                        setPendingTx(false);
                                    case 5:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: t("Confirm")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WithdrawModal);


/***/ }),

/***/ 64853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getDisplayApr; }
/* harmony export */ });
var getDisplayApr = function(cakeRewardsApr, lpRewardsApr) {
    if (cakeRewardsApr && lpRewardsApr) {
        return (cakeRewardsApr + lpRewardsApr).toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    if (cakeRewardsApr) {
        return cakeRewardsApr.toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    return null;
};


/***/ }),

/***/ 76807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21046);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5039);
/* harmony import */ var hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71228);






var useApproveFarm = function(lpContract) {
    var wkdLpPoolContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useWkdLpPool */ .ZB)();
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_3__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var handleApprove = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", callWithGasPrice(lpContract, "approve", [
                        wkdLpPoolContract.address,
                        _ethersproject_constants__WEBPACK_IMPORTED_MODULE_5__/* .MaxUint256 */ .Bz
                    ]));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        lpContract,
        wkdLpPoolContract,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useApproveFarm);


/***/ }),

/***/ 86507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16519);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5039);





var useHarvestFarm = function(farmPid) {
    var wkdLpPoolContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useWkdLpPool */ .ZB)();
    var handleHarvest = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .harvestFarm */ .sA)(wkdLpPoolContract, farmPid));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        farmPid,
        wkdLpPoolContract
    ]);
    return {
        onReward: handleHarvest
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useHarvestFarm);


/***/ }),

/***/ 60508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16519);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5039);





var useStakeFarms = function(pid) {
    var wkdLpPoolContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useWkdLpPool */ .ZB)();
    var handleStake = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .stakeFarm */ .AQ)(wkdLpPoolContract, pid, amount));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        wkdLpPoolContract,
        pid
    ]);
    return {
        onStake: handleStake
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStakeFarms);


/***/ }),

/***/ 97321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16519);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5039);





var useUnstakeFarms = function(pid) {
    var wkdLpPoolContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useWkdLpPool */ .ZB)();
    var handleUnstake = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(amount) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .unstakeFarm */ .dU)(wkdLpPoolContract, pid, amount));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        wkdLpPoolContract,
        pid
    ]);
    return {
        onUnstake: handleUnstake
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUnstakeFarms);


/***/ }),

/***/ 83210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* reexport safe */ _Farms__WEBPACK_IMPORTED_MODULE_1__.G; },
/* harmony export */   "S": function() { return /* binding */ FarmsPageLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Farms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37031);


var FarmsPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Farms__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: children
    });
};



/***/ }),

/***/ 17857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);
var countup_js = __webpack_require__(8273);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */

function useEventCallback(fn) {
  var ref = React.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
      decimals = props.decimals,
      duration = props.duration,
      easingFn = props.easingFn,
      end = props.end,
      formattingFn = props.formattingFn,
      numerals = props.numerals,
      prefix = props.prefix,
      separator = props.separator,
      start = props.start,
      suffix = props.suffix,
      useEasing = props.useEasing,
      enableScrollSpy = props.enableScrollSpy,
      scrollSpyDelay = props.scrollSpyDelay;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  startOnMount: true,
  enableReinitialize: true
};

var useCountUp = function useCountUp(props) {
  var _useMemo = React.useMemo(function () {
    return _objectSpread2(_objectSpread2({}, DEFAULTS), props);
  }, [props]),
      ref = _useMemo.ref,
      startOnMount = _useMemo.startOnMount,
      enableReinitialize = _useMemo.enableReinitialize,
      delay = _useMemo.delay,
      onEnd = _useMemo.onEnd,
      onStart = _useMemo.onStart,
      onPauseResume = _useMemo.onPauseResume,
      onReset = _useMemo.onReset,
      onUpdate = _useMemo.onUpdate,
      instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);

  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;

    if (countUp && !recreate) {
      return countUp;
    }

    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };

    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }

    onStart === null || onStart === void 0 ? void 0 : onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 ? void 0 : onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    timerRef.current && clearTimeout(timerRef.current);
    getCountUp().reset();
    onReset === null || onReset === void 0 ? void 0 : onReset({
      pauseResume: pauseResume,
      start: restart,
      update: update
    });
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }

      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];

var CountUp = function CountUp(props) {
  var className = props.className,
      redraw = props.redraw,
      containerProps = props.containerProps,
      children = props.children,
      style = props.style,
      useCountUpProps = _objectWithoutProperties(props, _excluded);

  var containerRef = React__default["default"].useRef(null);
  var isInitializedRef = React__default["default"].useRef(false);

  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
    ref: containerRef,
    startOnMount: typeof children !== 'function' || props.delay === 0,
    // component manually restarts
    enableReinitialize: false
  })),
      start = _useCountUp.start,
      reset = _useCountUp.reset,
      updateCountUp = _useCountUp.update,
      pauseResume = _useCountUp.pauseResume,
      getCountUp = _useCountUp.getCountUp;

  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }

    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    } // unlike the hook, the CountUp component initializes on mount


    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props; // if props.redraw, call this effect on every props change

  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]); // if not props.redraw, call this effect only when certain props are changed

  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);

  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }

  return /*#__PURE__*/React__default["default"].createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), props.start ? getCountUp().formattingFn(props.start) : '');
};

exports.ZP = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

}]);